import { Message, MessageState, State } from '../types';

export const unreadMessages = (state: State, fromReporter = false): number => {
  let unreadTotalCount = 0;
  const messagesMap = state?.globalReports?.messages || new Map();

  for (const [, message] of messagesMap.entries()) {
    const unreadMessages = message.filter(
      (m: Message) =>
        m?.state !== MessageState.READ && m?.isReporter === fromReporter,
    ).length;
    unreadTotalCount += unreadMessages;
  }
  return unreadTotalCount;
};

export const unreadOpenMessages = (
  state: State,
  fromReporter = false,
): number => {
  let unreadTotalCount = 0;
  const messagesMap =
    state?.openReporting?.openReportingReducer?.messages ?? new Map();

  for (const [, message] of messagesMap.entries()) {
    const unreadMessages =
      message?.filter(
        (m: Message) =>
          m?.state !== MessageState.READ && m?.isReporter === fromReporter,
      ).length ?? 0;
    unreadTotalCount += unreadMessages;
  }
  return unreadTotalCount;
};
